<template>
	<v-row>
		<v-col>
			<game-title></game-title>
			<game-slider></game-slider>
		</v-col>
	</v-row>
</template>

<script>
export default {
	data() {
		return {
			model: null,
		}
	},
	components: {
		"game-title": require("../common/gameTitle").default,
		"game-slider": require("../common/gameSlider").default,
	},
	computed: {
		pocketGameList() {
			return this.$store.getters["Casino/pocketGameList"]
		},
	},
}
</script>

<style lang="sass" scoped></style>
